module.exports = __webpack_public_path__ + "static/media/HourglassExpiring.418a0080.svg";